// extracted by mini-css-extract-plugin
module.exports = {"sponsored_banner_container":"sponsored_banner_container--eart1","slide":"slide--eart1","sponsored_banner_image":"sponsored_banner_image--eart1"};